// Wallet connection persistence using localStorage

const STORAGE_KEY = 'nullayer_wallet_connection'

interface WalletStorageData {
  address: string
  timestamp: number
}

export const saveWalletConnection = (address: string) => {
  const data: WalletStorageData = {
    address,
    timestamp: Date.now()
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export const getSavedWalletAddress = (): string | null => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (!stored) return null

    const data: WalletStorageData = JSON.parse(stored)

    // Check if the saved connection is less than 7 days old
    const sevenDaysInMs = 7 * 24 * 60 * 60 * 1000
    const isExpired = Date.now() - data.timestamp > sevenDaysInMs

    if (isExpired) {
      clearWalletConnection()
      return null
    }

    return data.address
  } catch (error) {
    console.error('Error reading wallet storage:', error)
    return null
  }
}

export const clearWalletConnection = () => {
  localStorage.removeItem(STORAGE_KEY)
}

export const hasStoredWalletConnection = (): boolean => {
  return getSavedWalletAddress() !== null
}
